<template>
  <div class="footerCom">
    {{msg}} © 版权所有
  </div>
</template>
<script>
export default {
  name: 'footerCom',
  data() {
    return {
      msg: ''
    }
  },
  created() {
    if (process.env.PROJECT === 'wwka') {
      this.msg = '北京赢销通软件技术有限公司'
    } else {
      this.msg = "北京惠赢天下网络技术有限公司"
    }
  },
  methods: {

  }
}
</script>
<style type="text/scss" lang="scss" scoped>
.footerCom {
  left:0px;
  position:absolute;
  bottom:0;
  height:30px;
  line-height:30px;
  color:#aaa;
  font-size:12px;
  text-align:center;
  right:0px;
}
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/components/footerCom.vue